<template>
  <div>
    <Head title="Tambah Pertanggung Jawaban" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/accountability-reports">Pertanggung Jawaban</Link>
      <span class="font-medium text-indigo-400">/</span> Tambah Data
    </h1>
    <div class="w-full bg-white rounded-md shadow">
      <form @submit.prevent="store">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <select-input
            v-model="form.semester" :error="form.errors.semester" class="w-full pb-8 pr-6 lg:w-1/3"
            label="Semester"
          >
            <option value="1">Semester 1</option>
            <option value="2">Semester 2</option>
            <option value="3">Semester 3</option>
            <option value="4">Semester 4</option>
            <option value="5">Semester 5</option>
            <option value="6">Semester 6</option>
            <option value="7">Semester 7</option>
            <option value="8">Semester 8</option>
          </select-input>
          <text-input
            v-model.number="form.account_number" type="number"
            :error="form.errors.account_number" class="w-full pb-8 pr-6 lg:w-1/3"
            label="Nomor Rekening Bank BPRS Cilegon Mandiri"
          />
          <text-input
            v-model.number="form.ipk" type="number" :error="form.errors.ipk" step="any"
            class="w-full pb-8 pr-6 lg:w-1/3" label="IPK Semester sebelumnya"
          />
        </div>
        <div class="flex items-center justify-end px-8 py-4 border-t border-gray-100 bg-gray-50">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            <font-awesome-icon class="mr-2" icon="fas fa-key" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '../../Shared/SelectInput.vue'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    SelectInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    scholarshipId: Number,
    periodeId: Number,
  },
  data() {
    return {
      form: this.$inertia.form({
        scholar_application_id: this.scholarshipId,
        accountability_report_periode_id: this.periodeId,
        account_number: 0,
        ipk: 0,
        semester: 1,
      }),
    }
  },

  methods: {
    store() {
      this.form.post(this.route('accountability-reports.store'))
    },
  },
}
</script>
